import { module } from "angular";
import { ButtonComponent } from "./ButtonComponent";

module("mmGui").component("irButton", new ButtonComponent());
